export default __webpack_public_path__ + "static/media/new2.2062e993.jpg";